// authentication
export const LOGIN = '@Authentication/LOGIN';
export const LOGOUT = '@Authentication/LOGOUT';
export const RECOVER_PASSWORD = '@Authentication/RECOVER_PASSWORD';

// user
export const GET_USER = '@User/GET_USER';
export const SET_TOKENS = '@User/SET_TOKENS';


// admins
export const GET_ADMINS = '@Admins/GET_ADMINS';
export const CREATE_ADMIN = '@Admins/CREATE_ADMIN';
export const DELETE_ADMIN = '@Admins/DELETE_ADMIN';
export const ACTIVATE_ADMIN = '@Admins/ACTIVATE_ADMIN';
export const RESETPASSWORD_ADMIN = '@Admins/RESETPASSWORD_ADMIN';
export const EDIT_ADMIN = '@Admins/EDIT_ADMIN';

// inspectors
export const GET_INSPECTORS = '@Inspectors/GET_INSPECTORS';
export const CREATE_INSPECTOR = '@Inspector/CREATE_INSPECTOR';
export const DELETE_INSPECTOR = '@Inspector/DELETE_INSPECTOR';
export const ACTIVATE_INSPECTOR = '@Inspector/ACTIVATE_INSPECTOR';
export const RESETPASSWORD_INSPECTOR = '@Inspector/RESETPASSWORD_INSPECTOR';
export const EDIT_INSPECTOR = '@Inspector/EDIT_INSPECTOR';

// supervisors
export const GET_SUPERVISORS = '@Supervisors/GET_SUPERVISORS';
export const CREATE_SUPERVISOR = '@Supervisor/CREATE_SUPERVISOR';
export const DELETE_SUPERVISOR = '@Supervisor/DELETE_SUPERVISOR';
export const ACTIVATE_SUPERVISOR = '@Supervisor/ACTIVATE_SUPERVISOR';
export const RESETPASSWORD_SUPERVISOR = '@Supervisor/RESETPASSWORD_SUPERVISOR';
export const EDIT_SUPERVISOR = '@Supervisor/EDIT_SUPERVISOR';

//inspectionApplications
export const GET_INSPECTIONAPPLICATIONS = '@inspectionApplications/GET_INSPECTIONAPPLICATIONS';
export const GET_INSPECTIONAPPLICATION_DETAIL = '@inspectionApplications/GET_INSPECTIONAPPLICATION_DETAIL';
export const CREATE_INSPECTIONAPPLICATIONS = '@inspectionApplications/CREATE_INSPECTIONAPPLICATIONS';